import { render, staticRenderFns } from "./ProductRecommend.vue?vue&type=template&id=5d521cfb&scoped=true"
import script from "./ProductRecommend.vue?vue&type=script&lang=js"
export * from "./ProductRecommend.vue?vue&type=script&lang=js"
import style0 from "./ProductRecommend.vue?vue&type=style&index=0&id=5d521cfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d521cfb",
  null
  
)

export default component.exports